import React from 'react';

const P = {
  fontSize: '1.0625rem',
  lineHeight: 1.85,
  color: 'var(--gray)',
  marginBottom: '1.5rem',
  fontWeight: 300,
  maxWidth: '68ch'
};

// Secção 7 · Conformidade (fundo branco)
const CREDENTIALS = [
  { label: 'CMVM', value: 'PAI/2025/0020' },
  { label: 'ANAI', value: 'Carteira n.º 1267' },
  { label: 'EVS 2025', value: 'TEGoVA' },
  { label: 'Cobertura', value: 'Nacional' }
];

export const AdvantagesSection = () => (
  <section className="valuare-section" data-testid="herancas-conformity-section">
    <div className="valuare-section-content">
      <div style={{ maxWidth: '820px', margin: '0 auto', textAlign: 'left' }}>
        <div className="valuare-section-label">Conformidade</div>
        <h2 className="valuare-section-title">
          Um relatório que<br />
          <em>resiste a escrutínio</em>
        </h2>
        <p style={P}>
          Os relatórios são elaborados por Perito Avaliador de Imóveis com registo ativo na
          Comissão do Mercado de Valores Mobiliários, em conformidade com as European Valuation
          Standards na edição de 2025 e com o Regulamento da CMVM n.º 2/2015, ao abrigo da Lei
          n.º 153/2015, de 14 de setembro.
        </p>
        <p style={{ ...P, marginBottom: 0 }}>
          Cada relatório identifica a amostra de comparáveis utilizada, explicita os critérios de
          homogeneização aplicados e declara os pressupostos e limitações considerados. É essa
          fundamentação que permite ao documento ser verificado por todos os interessados e
          apresentado a cartórios notariais, conservatórias e tribunais.
        </p>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: '1.5rem 2rem',
            marginTop: '3rem'
          }}
          data-testid="herancas-credentials"
        >
          {CREDENTIALS.map((c) => (
            <div key={c.label} style={{ borderLeft: '2px solid var(--gold)', paddingLeft: '18px' }}>
              <div
                style={{
                  fontSize: '0.65rem',
                  letterSpacing: '2.5px',
                  textTransform: 'uppercase',
                  color: 'var(--gold)',
                  fontWeight: 600,
                  marginBottom: '6px'
                }}
              >
                {c.label}
              </div>
              <div style={{ fontSize: '1rem', color: 'var(--navy)', fontWeight: 400 }}>{c.value}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
